export enum PAYMENT_PART {
  DURATION = "DURATION",
  CUSTOM_TOKEN = "CUSTOM_TOKEN",
  EMBEDDED = "EMBEDDED",
  SUBDOMAIN = "SUBDOMAIN",
}
